"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const volumehair = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-volumehair` : '') + (description ? ` desc-volumehair` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-volumehair"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-volumehair"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_26123_2726)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.07-.17c6.61 0 11.88 5.76 11.88 12.75 0 4.4-1.07 7.25-3.02 10.8a.75.75 0 0 1-1.32-.72c1.87-3.41 2.84-6.01 2.84-10.08 0-6.27-4.7-11.25-10.38-11.25-5.68 0-10.43 4.98-10.44 11.23v.05a13.22 13.22 0 0 0 .09 1c.07.66.2 1.6.42 2.64.44 2.1 1.24 4.58 2.62 6.3a.75.75 0 0 1-1.16.94c-1.62-2-2.47-4.75-2.93-6.93a29.11 29.11 0 0 1-.52-3.63l-.01-.23v-.08l-.01-.03v-.01c0-7 5.33-12.75 11.94-12.75Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.84 5.2a.77.77 0 0 1 .57.38l.1.2.1.31.1.4.14.47c.2.68.44 1.39.73 1.82.37.55.65.65.85.71l.36.1a1.34 1.34 0 0 1 .82.54l.08.1.06.14c.05.14.07.26.08.34l.02.43a13.71 13.71 0 0 1-.85 4.11 7.87 7.87 0 0 1-2.38 3.44 24.91 24.91 0 0 0 .34 2.58l.07.22v.01a.75.75 0 0 1-1.11 1 1.33 1.33 0 0 1-.28-.44 9.88 9.88 0 0 1-.32-1.4c-.06-.4-.1-.83-.14-1.21a4.74 4.74 0 0 1-2.9-.02c-.03.4-.07.84-.15 1.25-.06.36-.15.74-.28 1.06-.12.29-.34.7-.75.9a.75.75 0 0 1-.72-1.31 3.78 3.78 0 0 0 .28-.9c.1-.62.14-1.32.14-1.78a8.44 8.44 0 0 1-2.37-2.96c-.5-1-.85-2.06-1.03-2.98-.09-.46-.14-.9-.15-1.28 0-.38.03-.76.15-1.08l.05-.12c.13-.25.32-.42.51-.53.2-.12.44-.2.65-.24.42-.1.94-.14 1.42-.18.5-.04 1-.08 1.47-.16s.86-.19 1.14-.34a4.5 4.5 0 0 0 1.59-1.82l.27-.51.24-.46c.07-.13.16-.28.26-.4a.9.9 0 0 1 .74-.39h.1Zm-.32 2.53a5.9 5.9 0 0 1-2.16 2.36c-.5.28-1.07.42-1.62.51-.54.1-1.1.14-1.6.17a8.91 8.91 0 0 0-1.36.2c-.02.09-.03.23-.03.43 0 .28.05.63.12 1.02.16.79.46 1.71.9 2.59.91 1.8 2.28 3.15 3.97 3.15 1.88 0 3.1-1.51 3.85-3.45a12.21 12.21 0 0 0 .76-3.58v-.11L16.3 11l-.28-.08a2.91 2.91 0 0 1-1.69-1.32 7.64 7.64 0 0 1-.81-1.88Z",
    fill: "#232323"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_26123_2726"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = volumehair;